// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"65b395ee","130":"007ca37a","208":"e1a21341","350":"f5ad01c2","453":"d456ce70","786":"a77ea2f4","995":"aa817ef4"}[chunkId] + ".chunk.js";
};